import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  setNextBet as dispatchSetNextBet,
  setPrevBet as dispatchSetPrevBet,
  showList as dispatchShowList
} from '../actions';
import { countOpenBets, getCurrentBetIndex, hasNextBet, hasPreviousBet } from '../selectors';

export const SingleBetNavigation = ({
  betsCount,
  currentBetIndex,
  prevBet,
  nextBet,
  setPrevBet,
  setNextBet,
  showList
}) => (
  <div className="open-bet-single-navbar">
    <div className="container--fixed">
      <div className="open-bet-single-navbar__buttons">
        <div className="open-bet-single-navbar__cell open-bet-single-navbar__cell--left">
          {
            prevBet ? (
              <button
                type="button"
                className="open-bet-single-navbar__button"
                onClick={() => setPrevBet()}
              >
                Previous
              </button>
            ) : null
          }
        </div>
        <div className="open-bet-single-navbar__cell">
          <button
            type="button"
            className="open-bet-single-navbar__button"
            onClick={showList}
          >
            Bet {currentBetIndex} of {betsCount}
            <div className="open-bet-single__dropdown-button">
              <i className="material-icon material-icon--arrow-drop-down" />
            </div>
          </button>
        </div>
        <div className="open-bet-single-navbar__cell open-bet-single-navbar__cell--right">
          {nextBet && (
            <button
              type="button"
              className="open-bet-single-navbar__button"
              onClick={() => setNextBet()}
            >
              Next
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
);

SingleBetNavigation.propTypes = {
  betsCount: PropTypes.number.isRequired,
  currentBetIndex: PropTypes.number.isRequired,
  prevBet: PropTypes.bool.isRequired,
  nextBet: PropTypes.bool.isRequired,
  setPrevBet: PropTypes.func.isRequired,
  setNextBet: PropTypes.func.isRequired,
  showList: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  betsCount: countOpenBets(state),
  currentBetIndex: getCurrentBetIndex(state),
  prevBet: hasPreviousBet(state),
  nextBet: hasNextBet(state)
});

const mapDispatchToProps = {
  setNextBet: dispatchSetNextBet,
  setPrevBet: dispatchSetPrevBet,
  showList: dispatchShowList
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleBetNavigation);
